<template>
  <div>
    <b-row>
      <b-col lg="4" v-if="templates">
        <b-row>
          <component
            :is="scrollbarTag"
            ref="scroll2"
            class="vs-input--label scroll-area--data-list-add-new"
            :settings="settings"
            :key="$vs.rtl"
          >
            <b-row style="padding-right: 8px">
              <b-col
                lg="6"
                style="padding-right: 2px"
                v-for="(temp, ind) in templates"
                :key="temp.TemplateDefinitionId"
                v-on:click="getSelectedTemplate(temp, ind)"
              >
                <vs-card :class="temp.isSelected == 'selected' ? 'bg-success' : ''">
                  <div>
                    <b-row>
                      <b-col>
                        <b-button
                          v-on:click="
                            isSidebarActiveProcessDlt = true;
                            deleteBarcode = temp;
                          "
                          size="sm"
                          variant="outline-light"
                        >
                          <Icon
                            icon="material-symbols:close"
                            width="25"
                            height="25"
                            v-b-tooltip.hover.bottom="$t('Delete')"
                            color="#ea5455"
                          />
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <grid-layout
                    :layout="temp.TemplateDefinitionValue"
                    :col-num="12"
                    :row-height="1"
                    :is-draggable="false"
                    :is-resizable="false"
                    :vertical-compact="true"
                    :use-css-transforms="true"
                  >
                    <grid-item
                      v-for="item in temp.TemplateDefinitionValue"
                      :key="`${temp.TemplateDefinitionId}-${item.i}`"
                      :i="item.i"
                      :x="item.x"
                      :y="item.y"
                      :w="item.w"
                      :h="item.h"
                    >
                      <span class="text" v-if="item.barcode">
                        <barcode
                          :value="item.barcode"
                          format="CODE128"
                          :text-options="{ fontSize: 8 }"
                          style="width: 100%; height: 100%; text-align: center"
                        />
                      </span>
                      <span class="text" v-else-if="item.barcodeDynamic">
                        <barcode
                          :value="item.barcodeDynamic"
                          format="CODE128"
                          :text-options="{ fontSize: 8 }"
                          style="width: 100%; height: 100%; text-align: center"
                        />
                      </span>
                      <div
                        class="grid-item-content"
                        style="text-align: center; font-size: 6px"
                        v-else-if="item.label"
                      >
                        {{ item.label }}
                      </div>
                      <span class="text" v-else style="font-size: 6px"
                        >{{ item.item }}
                      </span>
                    </grid-item>
                  </grid-layout>
                </vs-card>
              </b-col>
            </b-row>
          </component>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <vs-card>
            <b-row>
              <b-col>
                <b-row>
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      :label="$t('Width')"
                      class="vs-input--label pr-0 mr-0"
                      label-for="h-first-name"
                      style="font-weight: 600"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-input
                      size="small"
                      v-model="width"
                      type="number"
                      class="w-full"
                      name="width"
                      v-validate="'required'"
                      placeholder="Genişlik girin (ör. 30mm)"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('width')">{{
                      errors.first("width")
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      :label="$t('Height')"
                      class="vs-input--label pr-0 mr-0"
                      label-for="h-first-name"
                      style="font-weight: 600"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-input
                      size="small"
                      v-model="height"
                      type="number"
                      class="w-full"
                      name="height"
                      v-validate="'required'"
                      placeholder="Yükseklik girin (ör. 30mm)"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('height')">{{
                      errors.first("height")
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
							<b-col>
                <b-row>
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      :label="$t('BarcodeWidth')"
                      class="vs-input--label pr-0 mr-0"
                      label-for="h-first-name"
                      style="font-weight: 600"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-input
                      size="small"
                      v-model="barcodeWidth"
                      type="number"
                      class="w-full"
                      name="barcodeWidth"
                      v-validate="'required'"
                      placeholder="Yükseklik girin (ör. 30mm)"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('barcodeWidth')">{{
                      errors.first("barcodeWidth")
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-row align-h="end">
                <b-col lg="2">
                  <b-button
                    class="bg-primary mt-3"
                    style="border-color: white; width: 100%"
                    v-on:click="
                      allPrintValidate = true;
                      printBarcodeQty();
                    "
                  >
                    <Icon icon="material-symbols:print-outline" width="20" height="20" />
                    {{ $t("Print") }}</b-button
                  >
                </b-col>
              </b-row>
            </b-row>
          </vs-card>
        </b-row>
        <div ref="printProductBarcode">
          <div
            v-if="selectedTemp"
            v-for="(itemMain, indexMain) in data"
            :key="indexMain"
            style="margin-bottom: 50px"
          >
            <b-row class="no-print" v-if="!allPrintValidate">
              <b-row align-h="end">
                <b-col lg="2">
                  <b-button
                    class="bg-primary mt-3"
                    style="border-color: white; width: 100%"
                    v-on:click="
                      printIndex = indexMain;
                      printBarcodeItem();
                    "
                  >
                    <Icon icon="material-symbols:print-outline" width="20" height="20" />
                  </b-button>
                </b-col>
              </b-row>
            </b-row>
            <vs-card :style="'width: ' + width + 'mm; height: ' + height + 'mm'">
              <grid-layout
                :layout="selectedTemp.TemplateDefinitionValue"
                :col-num="12"
                :row-height="5"
                :is-draggable="true"
                :is-resizable="true"
                :margin="[10, 10]"
              >
                <grid-item
                  v-for="(item, index) in selectedTemp.TemplateDefinitionValue"
                  :key="item.i + '-' + item.x"
                  :i="item.i"
                  :x="item.x"
                  :y="item.y"
                  :w="item.w"
                  :h="item.h"
                >
                  <div v-if="item.barcode" style="height: 100%">
                    <barcode
                      :value="
                        itemMain[item.value]
                          ? itemMain[item.value]
                              .replace('ı', 'i')
                              .replace('ü', 'u')
                              .replace('ö', 'o')
                              .replace('ş', 's')
                          : item.barcode
                      "
                      format="CODE128" 
                      :width="item.barcodeWidth"
                      :height="item.barcodeHeight" 
                    />
                  </div>
                  <div
                    v-else-if="item.barcodeDynamic"
                    style="height: 100%"
                    @click="setBarcodeValue(item, index)"
                  >
                    <barcode
                      :value="
                        itemMain[item.value]
                          ? itemMain[item.value]
                              .replace('ı', 'i')
                              .replace('ü', 'u')
                              .replace('ö', 'o')
                              .replace('ş', 's')
                          : item.barcodeDynamic
                      "
                      format="CODE128"
                      :text-options="{ fontSize: 1000 }" 
											:width="item.barcodeWidth"
                      :height="item.barcodeHeight" 
                    />
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else-if="item.label"
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    {{ item.label }}
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else-if="item.element == 'horizontalLine'"
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    <hr style="width: 100%; height: 3px; border-top: 2px solid #000" />
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else-if="item.element == 'verticalLine'"
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    <div
                      class="vertical-line"
                      style="
                        width: 2px;
                        height: 100%;
                        background-color: #000;
                        margin: 0 auto;
                      "
                    ></div>
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    {{ itemMain[item.value] ? itemMain[item.value] : item.item }}
                  </div>
                </grid-item>
              </grid-layout>
            </vs-card>
          </div>
        </div>
      </b-col>
    </b-row>
    <div ref="printProductBarcodeItem">
      <vs-card
        :style="'width: ' + width + 'mm; height: ' + height + 'mm'"
        v-if="data && templates && selectedTemp"
      >
        <grid-layout
          :layout="selectedTemp.TemplateDefinitionValue"
          :col-num="12"
          :row-height="5"
          :is-draggable="true"
          :is-resizable="true"
          :margin="[10, 10]"
        >
          <grid-item
            v-for="(item, index) in selectedTemp.TemplateDefinitionValue"
            :key="item.i + '-' + item.x"
            :i="item.i"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
          >
            <div v-if="item.barcode" style="height: 100%">
              <barcode
                :value="
                  data[printIndex][item.value]
                    ? data[printIndex][item.value]
                    : item.barcode
                "
                format="CODE128"
                :text-options="{ fontSize: 1000 }"
                :width="item.barcodeWidth"
                :height="item.barcodeHeight" 
              />
            </div>
            <div
              v-else-if="item.barcodeDynamic"
              style="height: 100%"
              @click="setBarcodeValue(item, index)"
            >
              <barcode
                :value="
                  data[printIndex][item.value]
                    ? data[printIndex][item.value]
                    : item.barcodeDynamic
                "
                format="CODE128"
                :text-options="{ fontSize: 1000 }"
                :width="item.barcodeWidth"
                :height="item.barcodeHeight" 
              />
            </div>
            <div
              class="grid-item-content"
              style="text-align: center"
              v-else-if="item.label"
              :style="{ fontSize: item.fontSize + 'px' }"
            >
              {{ item.label }}
            </div>
            <div
              class="grid-item-content"
              style="text-align: center"
              v-else-if="item.element == 'horizontalLine'"
              :style="{ fontSize: item.fontSize + 'px' }"
            >
              <hr style="width: 100%; height: 3px; border-top: 2px solid #000" />
            </div>
            <div
              class="grid-item-content"
              style="text-align: center"
              v-else-if="item.element == 'verticalLine'"
              :style="{ fontSize: item.fontSize + 'px' }"
            >
              <div
                class="vertical-line"
                style="width: 2px; height: 100%; background-color: #000; margin: 0 auto"
              ></div>
            </div>
            <div
              class="grid-item-content"
              style="text-align: center"
              v-else
              :style="{ fontSize: item.fontSize + 'px' }"
            >
              {{
                data[printIndex][item.value] ? data[printIndex][item.value] : item.item
              }}
            </div>
          </grid-item>
        </grid-layout>
      </vs-card>
    </div>

    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="changeBarcode"
      :active.sync="isSidebarActiveProcess"
      color="primary"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <v-select
                color="danger"
                v-model="selectedBarcodeValue"
                :options="barcode_options"
                size="small"
                autocomplete
                ref="selectElement"
                name="customer"
                :taggable="true"
              >
              </v-select>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="deletesubmit"
      :active.sync="isSidebarActiveProcessDlt"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { GridLayout, GridItem } from "vue-grid-layout";
import { Icon } from "@iconify/vue2";
import Barcode from "vue-barcode";
import vSelect from "vue-select";
import moment from "moment";
export default {
  components: {
    vSelect,
    VuePerfectScrollbar,
    GridLayout,
    GridItem,
    Icon,
    Barcode,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
			barcodeWidth:1,
      printIndex: 0,
      deleteBarcode: "",
      allPrintValidate: false,
      isSidebarActiveProcessDlt: false,
      isSidebarActiveProcess: false,
      selectedTemp: "",
      width: 0.0,
      height: 0.0,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      templates: [],
      selectedItemBarcode: [],
      selectedIndexBarcode: "",
      selectedBarcodeValue: "",
      barcode_options: [],
    };
  },
  methods: {
    getToday() {
      let today = new Date();
      return moment(String(today)).format("DD.MM.YYYY hh:mm:ss");
    },
    deletesubmit() {
      const vs = this.$vs;
      this.$store
        .dispatch("template/deleteTemplate", this.deleteBarcode.TemplateDefinitionId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getTemplateList();
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeBarcode() {
      this.selectedTemp.TemplateDefinitionValue[
        this.selectedIndexBarcode
      ].value = this.selectedBarcodeValue;
    },
    setBarcodeValue(item, index) {
      this.barcode_options = Object.keys(this.data[0]);
      this.selectedItemBarcode = item;
      this.selectedIndexBarcode = index;

      this.isSidebarActiveProcess = true;
    },
    printBarcodeItem() {
      setTimeout(() => {
        const printContents = this.$refs.printProductBarcodeItem.innerHTML;
        const printWindow = window.open("", "", "height=600,width=800");

        printWindow.document.write(`
          <html>
            <head>
              <title>Etiket Yazdır</title>
              <style>
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                  }
                  .vs-card {
                    width: ${this.width}mm;
                    height: ${this.height}mm;
                    margin: 0 auto;
                    page-break-inside: avoid;
                  }
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      }, 2000);
    },
    printBarcodeQty() {
      setTimeout(() => {
        const printContents = this.$refs.printProductBarcode.innerHTML;
        const printWindow = window.open("", "", "height=600,width=800");

        printWindow.document.write(`
          <html>
            <head>
              <title>Etiket Yazdır</title>
              <style>
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                  }
                  .vs-card {
                    width: ${this.width}mm;
                    height: ${this.height}mm;
                    margin: 0 auto;
                    page-break-inside: avoid;
                  }
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      }, 2000);

      setTimeout(() => {
        this.allPrintValidate = false;
      }, 4000);
    },
    getTemplateList() {
      const vs = this.$vs;
      let compId = "";

      if (typeof this.data[0].companyId == "undefined")
        compId = this.$store.state.AppActiveUser.companyid;
      else compId = this.data[0].companyId;
      this.$store
        .dispatch("template/listTemplatesByName", this.name)
        .then((response) => {
          if (response.success == true) {
            try {
              let datas = JSON.parse(response.json);
              datas.forEach((val, index) => {
                let lcItem = JSON.parse(val.TemplateDefinitionValue);
                datas[index].TemplateDefinitionValue = lcItem;
                lcItem.forEach((value, ind) => {
                  datas[index].TemplateDefinitionValue[ind].i = datas[
                    index
                  ].TemplateDefinitionValue[ind].i.toString();

                  datas[index].TemplateDefinitionValue[ind].static = true;
                });
              });
              this.templates = datas;
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else {
            this.templates = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSelectedTemplate(item, ind) {
      this.selectedTemp = item;
      this.width = this.selectedTemp.TemplateDefinitionWith;
      this.height = this.selectedTemp.TemplateDefinitionHeight;
      this.templates.forEach((val, index) => {
        this.templates[index].isSelected = "";
      });
      this.templates[ind].isSelected = "selected";
      this.mainLayout = this.selectedTemp.TemplateDefinitionValue;
    },
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val == true) {
        this.getTemplateList();
      }
      return val;
    },
    data(val) {
      return val;
    },
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table-barcode-prt {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 210px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}

.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  cursor: pointer;
}
.vue-barcode-element {
  height: 100%;
  width: 100%;
}
.scroll-area--data-list-add-new-barcode-prt {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 90px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.con-vs-dialog {
  z-index: 520055;
}
.vertical-line {
  width: 2px;
  height: 100%;
  background-color: #000;
  margin: 0 auto;
}
@media print {
  .vertical-line {
    width: 2px;
    height: 100%;
    background-color: #000;
    margin: 0 auto;
  }
  .no-print {
    display: none !important;
  }
}
.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 140px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
